import * as types from '../actions/_actionTypes';
import initialState from './_initialState';

export default function integrationJobReducer(state = initialState.integrationJob, action: any) {
    switch (action.type) {
        case types.SAVE_INTEGRATION_JOB_DATA:
            return action.integrationJob;
        default:
            return state;
    }
}
